/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDate } from '@js-joda/core';
import DateUtils from 'src/utils/date';
import { AccountModel } from './account.model';
import { FundingSourceModel } from './funding-source.model';

export enum CardType {
    goal = 'goal',
    event = 'event'
}

export enum WarningType {
    /** If this card's start date is before the income it references has started */
    beforeIncomeStarts = 'beforeIncomeStarts',

    /** If this card references an income that has already ended on this card's startDate */
    afterIncomeEnds = 'afterIncomeEnds',

    /** If this card references an income that does not start, either by a Card or a manual or guessed income */
    incomeNeverStarts = 'incomeNeverStarts',

    /** Present when this card requires an income in the modifyIncomes or createIncomes field, but there is none */
    requiresIncome = 'requiresIncome'
}

export class CardModel {
    id?: number;
    description!: string;
    startDate!: LocalDate;
    endDate!: LocalDate;
    attributes?: {
        [key: string]: any;
    };

    overlaps?: any;
    layer?: number;
    left?: number;
    right?: number;
    accountId?: number;
    account?: AccountModel;
    nickname?: string;
    startIncomes: any[];
    modifyIncomes: any[];
    created?: Date;
    updated?: Date;
    warnings?: Array<{
        type: WarningType;
        detail: String;
    }>;

    fundingSources?: FundingSourceModel[];
    investmentIds?: number[];
    yPosition?: number;
    createdBy?: string;
    hash?: string;
    amountSaved?: number;
    percentSaved?: number;
    savingsCardDescription?: string;
    scenarioUid?: string;

    public static serialize(model: CardModel): string {
        return JSON.stringify(this);
    }

    public static deserializeDates(model: CardModel): CardModel {
        model.startDate = model.startDate && DateUtils.dateify(model.startDate);
        model.endDate = model.endDate && DateUtils.dateify(model.endDate);
        return model;
    }

    public static deserialize(input: string): CardModel {
        const model: CardModel = JSON.parse(input);
        return this.deserializeDates(model);
    }

    public static dateify(cardSource: CardModel): CardModel {
        return {
            ...cardSource,
            startDate: DateUtils.dateify(cardSource.startDate),
            endDate: DateUtils.dateify(cardSource.endDate)
        };
    }
}
